import Grow from '@material-ui/core/Grow'

interface Props {
  $skillRef: React.RefObject<HTMLIFrameElement>
  handleSkillLoad: () => void
  height: number
  src: string
}

export function SkillIFrame({ $skillRef, height, src, handleSkillLoad }: Props) {
  return (
    <Grow in timeout={1000}>
      <iframe
        ref={$skillRef}
        scrolling="no"
        src={src}
        style={{ display: 'block', border: 'none', width: '100%', height }}
        onLoad={handleSkillLoad}
      />
    </Grow>
  )
}
